export default {
  //给queryGroupPlus 设置样式
  overflow: {
    type: String,
    default: 'hidden',
  },
  // 20191123-lqn-（运营平台-市场运营-产品组-关联产品表格行操作启用停用）
  menuEnableUrl: {
    type: String,
    default: '',
  },
  // -------------------------------------------------------
  store: {
    type: Object,
    default: null,
  },
  // 查询table数据地址
  urlQuery: {
    type: String,
    require: true,
    default: '',
  },
  // 查询地址-参数
  urlQueryParamter: {
    type: Object,
    default: null,
  },
  // 查询table请求方式
  urlQueryMethod: {
    type: String,
    default: 'post',
  },
  // 查询关键词参数名
  searchKey: {
    type: String,
    default: 'keyword',
  },

  pageSize: {
    type: Number,
    default: 10,
  },

  turnOnPaging: {
    type: Number,
    default: 50,
  },
  pageSizeOpts: {
    type: Array,
    default: () => [10, 20, 30, 50],
  },
  selection: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '编辑',
  },
  sideModalWidth: {
    type: [String, Number],
    default: '',
  },
  choiceSideModalTitle: {
    type: String,
    default: '请选择',
  },
  sideModalBtn: {
    type: String,
    default: '确定',
  },
  menuAddName: {
    type: String,
    default: '增加',
  },
  menuRemoveName: {
    type: String,
    default: '删除',
  },
  menuShow: {
    type: Boolean,
    default: true,
  },
  menuAddShow: {
    type: Boolean,
    default: false,
  },
  show8649Btn: {
    type: Boolean,
    default: false,
  },
  menuDeleteShow: {
    type: Boolean,
    default: true,
  },
  menuInsertShow: {
    type: Boolean,
    default: true,
  },
  menuSplitShow: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  draggable: {
    type: Boolean,
    default: false,
  },
  // value: {
  //   type: [Array],
  //   default: () => []
  // },
  indexLabel: {
    type: String,
    default: '序号',
  },
  // 表单配置请求URL
  urlItemsDef: {
    type: String,
    default: null,
  },
  // 列表定义配置获取URL
  tableColumnDefUrl: {
    type: String,
    default: 'rest/main/dict/getTableByCode?tableCode=',
  },
  // 列表定义配置
  tableColumnDef: {
    type: Object,
  },
  removeAll: {
    type: Boolean,
    default: false,
  },

  menuChooseName: {
    type: String,
    default: '选择',
  },
  chooseUrl: {
    type: String,
    default: '',
  },
  chooseIndex: {
    type: Boolean,
    default: true,
  },
  chooseRequestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  chooseRequestParam: {
    type: [String, Object],
    default: null,
  },
  chooseSearchKey: {
    type: String,
    default: 'keyword',
  },
  // 启用校验时候，指定校验的key
  rowDataKey: {
    type: String,
    default: 'items',
  },
  chooseTableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },

  addDefaultData: {
    type: Object,
    default: () => {},
  },

  // 自定义操作栏表头名称
  operateCell: {
    type: String,
    default: '操作',
  },
  // 自定义判重字段
  convertArray: {
    type: Array,
    default: () => [],
  },
  // 是否启用自定义判重字段
  isConvertArray: {
    type: Boolean,
    default: false,
  },
  showSortBatch: {
    type: Boolean,
    default: false,
  },
  checkField: {
    type: String,
    default: 'id',
  },
  paddingTop: {
    type: [String, Number],
    default: 15,
  },
  openValidation: {
    type: Boolean,
    default: true,
  },
  showDoubleRow: {
    type: Boolean,
    default: false,
  },
  doubleRowOptions: {
    type: Array,
    default: () => {
      return [
        {
          value: 'all',
          label: '显示双方商品',
        },
        {
          value: 'one',
          label: '显示己方商品',
        },
        {
          value: 'two',
          label: '显示对方商品',
        },
      ]
    },
  },
  doubleRowData: {
    type: Array,
    default: () => {
      return []
    },
  },
  doubleRowDataKey: {
    type: String,
    default: 'item_',
  },
  buttonMenuListUrl: {
    type: String,
    default: '',
  },
  buttonMenuListRowUrl: {
    type: String,
    default: '',
  },
  routeQuery: {
    type: Object,
    default: () => {
      return {}
    },
  },

  useMaster: {
    type: Boolean,
    default: false,
  },
  menuDeleteInfo: {
    type: Object,
    default: () => {
      return {
        url: '',
        method: 'post',
        param: '',
      }
    },
  },
  menuEditInfo: {
    type: Object,
    default: () => {
      return {
        type: 'custom',
        url: '',
        method: 'post',
        param: '',
        addKey: '',
      }
    },
  },
  isShowOptionEdit: {
    type: Boolean,
    default: false,
  },
  menuEditShow: {
    type: Boolean,
    default: false,
  },
  defaultDisplayValue: String, // 默认的选择查询 value
  selectSearchOptions: {
    type: Array,
    default: () => {
      return [
        {
          value: 'DISPLAY_ALL',
          label: '显示全部',
        },
        {
          value: 'DISPLAY_MAPPED',
          label: '显示已映射商品',
        },
        {
          value: 'DISPLAY_TO_BE_MAPPED',
          label: '显示待映射商品',
        },
      ]
    },
  },
  defaultDisplayValue2: String, // 默认的选择查询 value
  selectSearchOptions2: {
    type: Array,
    default: () => {
      return [
        {
          value: 'DISPLAY_ALL',
          label: '显示全部',
        },
        {
          value: 'DISPLAY_MAPPED',
          label: '显示已映射商品',
        },
        {
          value: 'DISPLAY_TO_BE_MAPPED',
          label: '显示待映射商品',
        },
      ]
    },
  },
  selectPlaceholder: {
    type: String,
    default: '请选择',
  },
  selectPlaceholder2: {
    type: String,
    default: '请选择',
  },
  searchPlaceholder: {
    type: Object,
    default: () => {
      return {
        msg: '商品编码/商品名称/规格型号',
        isShow: false,
      }
    },
  },
  height: {
    type: [String, Number],
  },
  menuMapingShow: {
    type: Boolean,
    default: false,
  },
  // 按钮【映射商品】请求接口地址，#5541 【灵科+优联-web-海南】商品映射需要支持双向映射
  urlQueryOfMapingGoods: {
    type: String,
    default: 'rest/main/goods/friend_mate/queryGoodsListForFriendMateByIBP',
  },
  useBackCount: {
    type: String,
    default: null,
  },
  // 20190301-lqn-（运营平台-市场运营-产品组-关联商品表格后端无法实现分页（荣华兴））
  showPage: {
    type: Boolean,
    default: true,
  },
  onSideBotom: {
    type: Number,
    default: 0,
  },
  showTopBtn: {
    type: Boolean,
    default: false,
  },
  //是否显示顶部搜索
  isShowSearch: {
    type: Boolean,
    default: false,
  },
  //查询的高级查询地址
  criteriaFormUrl: {
    type: String,
    default: '',
  },
  //查询表单列表定义配置获取URL
  searchTableColumnDefUrl: {
    type: String,
    default: '',
  },

  //是否显示另外一种顶部搜索
  isShowQueryGroup: {
    type: Boolean,
    default: false,
  },
  //查询的高级查询地址
  groupSearchFormUrl: {
    type: String,
    default: '',
  },
  //是否显示合计
  isShowSummary: {
    type: Boolean,
    default: true,
  },
  //是否显示底部按钮
  isShowFooterBtn: {
    type: Boolean,
    default: false,
  },
  //底部按钮名称
  sureAndClose: {
    type: String,
    default: '提交并关闭',
  },
  //底部按钮名称
  sureAndContinue: {
    type: String,
    default: '提交并继续',
  },

  //清除指定字段
  clearField: {
    type: String,
    default: 'code',
  },
  //是否显示 提交并继续
  isShowContinue: {
    type: Boolean,
    default: true,
  },
  //上一个表单的数据
  preFromData: {
    type: Object,
    default: () => {},
  },
  //路由参数
  routerParams: {
    type: Object,
    default: () => {},
  },
  isModal: {
    type: Boolean,
    default: false,
  },
  highlightCurrentRow: {
    type: Boolean,
    default: false,
  },
  //商品选择器使用 如果是商品选择器左侧是否展开还是收起
  showLeft: {
    type: Boolean,
    default: false,
  },
  //收起
  collapse: {
    type: Number,
    default: 180,
  },
  //展开
  unfold: { type: Number, default: 243 },
  //是否显示加载
  isShowLoading: {
    type: Boolean,
    default: false,
  },
  //是否需要计算表格header浮动
  tableFixed: {
    type: Boolean,
    default: true,
  },
  //扩展传递的数据 针对手术配货
  otherData: {
    type: Object,
    default: () => ({}),
  },
  //是否是商品选择器
  isGoodSelct: {
    type: Boolean,
    default: false,
  },
}
